import axios from "../index"

// 接口基础路径
const rootApi = '/api_v2/station/document'

/** 获取根节点 */
export const edmRootNodes = () => {
  return axios.get(`${rootApi}/rootNodes`)
}

/** 获取子目录 */
export const getEdmChildrenNodes = (parentId) => {
  return axios.get(`${rootApi}/children/${parentId}`)
}

/** 分页查询文档 */
export const searchEdmDocPage = (params) => {
  return axios.get(`${rootApi}/docPage`, {params})
}

/** 获取单个文档详细属性 */
export const getEdmDoc = (docId) => {
  return axios.get(`/api_v2/document/doc/${docId}`)
}
